import React, { useContext, createContext, useState } from 'react';
const Context = createContext({});
export default function Configuration({ children, ...props }) {
    const [state] = useState(props);
    return <Context.Provider value={state}>{children}</Context.Provider>;
}

export function useConfiguration() {
    const value = useContext(Context);
    return value;
}
